<template>
  <div>
    <Head title="Rutas" />
    <h1 class="mb-8 text-3xl font-bold">Rutas</h1>
    <div class="flex items-center justify-between mb-6">
      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <button class="btn-sky" @click="showDialog">Agregar Ruta</button>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">          
          <th class="pb-4 pt-6 px-2">Id</th>
          <th class="pb-4 pt-6 px-2">Codigo</th>
          <th class="pb-4 pt-6 px-2">Descripción</th>
          <th class="pb-4 pt-6 px-2">Clientes</th>
          <th class="pb-4 pt-6 px-2">Agregar cliente</th>
          <th class="pb-4 pt-6 px-2">Encargado(s)</th>
          <th class="pb-4 pt-6 px-2">Gestionar</th> 
          <th class="pb-4 pt-6 px-2">Agregar Descuento</th>      
        </tr>
        <tr v-for="route in route.data" :key="route.id" class="hover:bg-gray-100 focus-within:bg-gray-100">          
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/routes/${route.id}/edit`">
              {{ route.id }}                          <!--:href="`/routes/${route.id}/clients`"-->
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/routes/${route.id}/edit`">
              {{ route.codigo }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/routes/${route.id}/edit`">
              {{ route.descripcion }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/routes/${route.id}/clients/1`">
              <p class="text-blue-600">{{ route.cantidadClientes }}</p>
            </Link>
          </td>
          <td class="border-t">
            <button class="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" @click="goToClients(route.id)">
              Agregar Cliente                         
            </button>
          </td>
          <td class="border-t p-4">
            <button class="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800  rounded-lg text-sm px-5 py-2.5  "  @click="goToEmployee(route.id)">
              <icon name="users"  /> <!-- Clase de icono de Font Awesome -->
            </button>
          </td>
          <td class="border-t">
            <button type="button" class="text-white bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-teal-300 dark:focus:ring-teal-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"  @click="goToSubRoute(route.id)">Sub-rutas</button>
          </td>
          <td class="border-t text-center">
            <button type="button" class="text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" @click="showDialogDiscountList(route.id, route.descripcion)">Descuentos</button>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-6 py-4" :href="`/routes/${route.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="route.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">No se encontraron rutas.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="route.links" />
    <div>
      <DialogInput v-if="showDialogInput" v-model="dialogValue" label="Nombre" :title="'Crear ruta'" @close="closeDialog">     
        <form class="w-full max-w-sm py-2" @submit.prevent="store">
          <div>
            <text-input v-model="form.code" class="py-2 w-full" label="Código" />            
            <text-input v-model="form.description" class="py-2 w-full" label="Descripcion" />
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear</loading-button>
          </div>
          <span class="text-sm justify-end">Los clientes para las rutas podras agregarlos más adelante</span>
        </form>
      </DialogInput>
    </div>
    <div>
      <DialogInput v-if="showDialogAddEmployee"  label="Nombre" :title="'Encargados'" @close="showDialogAddEmployee = false">     
        <form class="w-full max-w-sm py-2" @submit.prevent="store">
          <div>
            <text-input v-model="form.code" class="py-2 w-full" label="Código" />            
            <text-input v-model="form.description" class="py-2 w-full" label="Descripcion" />
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear</loading-button>
          </div>
          <span class="text-sm justify-end">Los clientes para las rutas podras agregarlos más adelante</span>
        </form>
      </DialogInput>
    </div>
    <div>
      <DialogInput v-if="dialogPriceList" label="Precios" :title="'Agregar lista de precios'" @close="dialogPriceList = false">      
        <form class="w-full max-w-sm py-2" @submit.prevent="storePriceListoToRoute">
        <!-- <form class="w-full max-w-sm py-2"> -->
          <div>          
            <p class="text-lg">Ruta: <span class="font-medium">{{ description }}</span> </p>
            <select-input v-model="selectedOption" class="py-2 w-full text-lg" label="Lista de precios">
                <option v-for="list in listPrices" :key="list.id" :value="list.id">{{ list.description }}</option>
            </select-input> 
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Agregar</loading-button>
          </div>
          <span class="text-sm justify-end">La lista de precios se asignará a todos los clientes de la ruta seleccionada. Si después de esta asignación se añade un nuevo cliente, será necesario actualizar la lista. Esto se puede hacer repitiendo el mismo proceso o individualmente desde el apartado de clientes.</span>
        </form>
      </DialogInput>
    </div>
    <div>
      <DialogInput v-if="dialogDiscountList" label="Descuentos" :title="'Agregar descuento'" @close="dialogDiscountList = false">      
        <form class="w-full max-w-sm py-2" @submit.prevent="storeDiscountListoToRoute">
        <!-- <form class="w-full max-w-sm py-2"> -->
          <div>          
            <p class="text-lg">Ruta: <span class="font-medium">{{ description }}</span> </p>
            <Multiselect
              v-model="selectedDiscount"
              placeholder="Seleciona una o varias opciones"                      
              :options="listDiscounts.map(discount => ({ value: discount.id, label: discount.name }))" 
              mode="tags"
              :close-on-select="false"
              :searchable="true"                                    
            /> 
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Agregar</loading-button>
          </div>
          <span class="text-sm justify-end">El <strong>descuento</strong> se asignará a todos los clientes de la ruta seleccionada. Si después de esta asignación se añade un nuevo cliente, será necesario actualizar la lista. Esto se puede hacer <strong>repitiendo</strong> el mismo proceso o individualmente desde el apartado de clientes.</span>
        </form>
      </DialogInput>
    </div>
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Search from '@/Shared/Search'
import DialogInput from '@/Shared/Dialog'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'   
import Pagination from '@/Shared/Pagination'
import InputFile from '@/Shared/InputFile'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import Multiselect from '@vueform/multiselect'


export default {
  components: {
    Head,
    Link,
    Search,
    DialogInput,
    LoadingButton,
    TextInput,
    Icon,
    Pagination,
    SelectInput,
    TextareaInput,
    InputFile,
    Multiselect,
  },
  layout: Layout,
  props: {    
    route: Array,  
    // filters: Object,
    //codes: Object,
    //families: Object,
    //categories: Object,
    listPrices: Array,
    listDiscounts: Array,  
  },
  remember: 'form',
  data() {
    return {     
      form: this.$inertia.form({
        code:'',
        description:'',
        estatus:'',
        //search: this.filters.search,
        //code: this.filters.code,
      }),
      dialogValue: '',
      showDialogInput: false,
      showDialogAddEmployee: false,
      dialogPriceList: false,
      idRoute: '',
      description: '',
      selectedOption: null, 
      dialogDiscountList: false,
      selectedDiscount: null,      
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/routes', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    goToClients(routeId) {
      window.location.href = `/routes/${routeId}/clients`
    },  
    goToEmployee(routeId) {
      window.location.href = `/routes/${routeId}/employee`
    },
    goToSubRoute(routeId) {
      window.location.href = `/routes/${routeId}/sub-routes`
    },  
    store() {
      // Utilizando async/await para esperar la respuesta del envío de datos
      (async () => {
        try {
          await this.$inertia.post('/routes', this.form)
          // Si la respuesta es exitosa, puedes agregar aquí cualquier lógica adicional
          this.closeDialog()
        } catch (error) {
          console.error('Error al enviar datos:', error)
          // Puedes manejar el error aquí si es necesario
        }
      })()
    },
    storePriceListoToRoute() {
      (async () => {
        try {
          await this.$inertia.post('/add_price_list_to_route', {
            idRoute: this.idRoute,
            selectedOption: this.selectedOption
          });
          this.closeDialogPriceList();
        } catch (error) {
          console.error('Error al enviar datos:', error);
        }
      })();
    },
    storeDiscountListoToRoute() {
      (async () => {
        try {
          await this.$inertia.post('/add_discount_to_route', {
            idRoute: this.idRoute,
            selectedDiscount: this.selectedDiscount
          });
          this.closeDialogDiscountList();
        } catch (error) {
          console.error('Error al enviar datos:', error);
        }
      })();
    },

    showDialog() {
      this.showDialogInput = true 
    },
    closeDialog() {
      this.showDialogInput = false 
    },
    showDialogPriceList(routeId, description) {
      this.dialogPriceList = true;
      this.idRoute = routeId;
      this.description = description;
      console.log(`la ruta es: ${routeId}`);
    },
    closeDialogPriceList() {
      this.dialogPriceList = false 
    },    
    showDialogDiscountList(routeId, description) {
      this.dialogDiscountList = true;
      this.idRoute = routeId;
      this.description = description;
      console.log(`la ruta es: ${routeId}`);
    },
    closeDialogDiscountList() {
      this.dialogDiscountList = false 
    }, 
  },
}
</script>  
<style src="@vueform/multiselect/themes/default.css"></style>